"use client";

import React from "react";
import { SearchProvider } from "@dxp-feed/algolia";
import { algoliaConfig } from "@/services/algolia/config";
import { InstantSearchProps } from "react-instantsearch";

type AlgoliaSearchProviderProps = {
  indexName: string;
  routing?: boolean;
} & React.PropsWithChildren &
  Omit<InstantSearchProps, "searchClient">;

export default function AlgoliaSearchProvider(
  props: Readonly<AlgoliaSearchProviderProps>
) {
  const { indexName, children, routing = false, ...rest } = props;
  return (
    <SearchProvider
      appId={algoliaConfig.appId}
      apiKey={algoliaConfig.apiKey}
      indexName={indexName}
      routing={routing}
      {...rest}
    >
      {children}
    </SearchProvider>
  );
}
